import styled from 'styled-components'
import { color, space } from 'styled-system'

const ThemeWrapper = styled.div`
  ${color}
  ${space}
  
  body.using-mouse {
    *:focus {
      outline: none;
    }
  }

  a {
    text-decoration: none;
    color: inherit;
    cursor: pointer;

    &:focus {
      color: inherit;
    }
  }

  /* Remove margin for labels so toggle switches will look good on legacy pages */
  label {
    margin: 0px;
  }

  /* Remove padding so the volume bar will look good in RangeSlider on legacy pages */
  input[type='range'] {
    padding: 0;
  }
`

export default ThemeWrapper
